export enum CvLabelType {
  TasksAndResponsibilities = 'tasks',
  Areas = 'areas',
}

export const CV_LABEL_TYPE_I18N: Record<CvLabelType, string> = {
  [CvLabelType.Areas]: 'Bereiche',
  [CvLabelType.TasksAndResponsibilities]: 'Aufgaben',
};
